<template>
  <div class="page-gray">
    <unifiedHeader />
    <div class="register">
      <div class="mian">
        <div class="title">熊洞智家 | 注册会员</div>
        <div class="Mtitle">注册</div>
        <div class="content">
          <el-form>
            <div class="inputK">
              <input
                v-model="mobile"
                placeholder="请输入您的手机号"
                type="text"
                maxlength="11"
              />
            </div>
            <div class="captcha">
              <input v-model="captchaText" placeholder="请输入图形验证码" />
              <img :src="serialImg" alt @click="getCaptcha" />
            </div>
            <div class="captcha">
              <input v-model="captcha" placeholder="请输入验证码" />
              <span @click="flag && sendcode($event)">获取验证码</span>
            </div>
            <div class="inputK">
              <input
                placeholder="请输入密码"
                v-model="password"
                show-password
                type="text"
              />
            </div>
            <div class="agree">
              <el-checkbox
                @click="CheckItem(Agreement)"
                v-model="Agreement.state"
                >我已阅读并接受<span class="orange" @click="agree"
                  >用户协议</span
                ></el-checkbox
              >
            </div>
            <div class="butn" @click="register">注册</div>
            <div class="goToLogin" @click="goToLogin" v-if="!user.jrwyToken">
              已有账号，<span>马上登录</span>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footer">
      熊洞智家 智能家居服务平台 熊洞智家（北京）科技有限公司/无忧服务 版权所有
    </div>
  </div>
</template>

<script>
import cryptoPhp from '../../libs/common/cryptoPhp'; // 加密解密文件
import unifiedHeader from '@/components/common/unifiedHeader'; // 统一头部
import blurBack from '@/mixins/blurBack';
import captcha from '@/mixins/captcha';
import { loginApi } from '@/api';
import { mapGetters, mapActions } from 'vuex';
import { USER_SIGNIN, USER_SIGNOUT } from '@/store/auth';
import store from '@/store';
export default {
  computed: {
    ...mapGetters(['user'])
  },
  mixins: [blurBack, captcha],
  data() {
    return {
      mobile: '',
      password: '',
      captcha: '',
      flag: true,
      Agreement: [],
      source: 19
    };
  },
  components: {
    unifiedHeader
  },
  methods: {
    ...mapActions([USER_SIGNIN, USER_SIGNOUT]),
    // 已有账号，马上登录
    goToLogin() {
      this.$router.push({
        path: '/login'
      });
    },
    // 判断是否同意协议
    CheckItem(Agreement) {
      Agreement.state = !Agreement.state;
    },
    // 用户协议
    agree() {
      window.location = 'https://m.juranguanjia.com/Agreement/m';
    },
    // 发送手机验证码
    async sendcode(event) {
      if (!this.captchaText) {
        this.$message.error('请输入图形验证码！');
        return;
      }
      let el = event.currentTarget;
      let waitTime = 60;
      try {
        let params = {
          mobile: this.mobile,
          smsType: 1,
          captchaText: this.captchaText,
          captchaSerialNum: this.captchaSerialNum
        };
        let data = (await loginApi.sendcode(params)).data;
        if (data.statusCode === 200) {
          this.dingshiqi(el, waitTime);
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    },
    // 定时器
    dingshiqi(el, waitTime) {
      if (waitTime === 0) {
        this.flag = true;
        el.innerHTML = '重新获取验证码';
        waitTime = 60; // 恢复计时
        clearTimeout(() => {
          this.dingshiqi(el, waitTime);
        }, 1000);
      } else {
        el.innerHTML = waitTime + 's后重新发送';
        waitTime--;
        setTimeout(() => {
          this.dingshiqi(el, waitTime);
        }, 1000);
        this.flag = false;
      }
    },
    // 注册账号
    async register() {
      let userType = store.state.Role.role;
      if (userType === 'guangwang') {
        this.source = 18;
      } else {
        this.source = 19;
      }
      if (this.mobile === '') {
        this.$message.error('您的手机号码不能为空！');
      } else if (!this.mobile.match(/^1[3,4,5,7,8,9]\d{9}$/)) {
        this.$message.error('您的手机号码的格式不正确！');
      } else if (this.password === '') {
        this.$message.error('您的密码不能为空！');
      } else if (this.captcha === '') {
        this.$message.error('您的验证码不能为空！');
      } else {
        if (this.Agreement.state === true) {
          try {
            let params = {
              mobile: this.mobile,
              password: this.password,
              verifyCode: this.captcha,
              smsType: 1,
              userType: 1,
              source: this.source
            };
            // let data = (await loginApi.register(params)).data;
            let data = (await loginApi.ssoregister(params)).data;
            if (data.statusCode === 200) {
              if (
                window.localStorage.role === '2'
                || window.localStorage.role === '4'
                || window.localStorage.role === '5'
              ) {
                this.ssoauthentication(
                  data.data.jrwyToken,
                  window.localStorage.role
                );
              } else if (window.localStorage.role === 'guangwang') {
                let jrwyToken = cryptoPhp.Encrypt(data.data.jrwyToken);
                let backUrl
                  = cryptoPhp.Decrypt(window.localStorage.backurl)
                  + '?jrwyToken='
                  + encodeURIComponent(jrwyToken);
                window.location.href = encodeURI(backUrl);
              } else {
                this.$router.push({
                  path: 'Login'
                });
              }
            }
          } catch (err) {
            console.error(err);
          } finally {
          }
        } else {
          this.$message.error('请阅读并同意《熊洞智家用户服务协议》！');
        }
      }
    },
    async ssoauthentication(jrwyToken, role) {
      try {
        let params = {
          jrwyToken: jrwyToken,
          userType: 1
        };
        let data = (await loginApi.ssoauthentication(params)).data;
        if (data.statusCode === 200) {
          this.USER_SIGNIN(data.data);
          this.$router.push({
            path: '/worker/workerInfo?userType=' + role
          });
        } else {
          this.$message.error('登录失败！');
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    }
  }
};
</script>

<style scoped>
.page-gray {
  background: #f4f4f4;
  /* background: #fff; */
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
}
.register {
  width: 15rem;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  overflow: hidden;
}
.register .mian {
  width: 100%;
  margin-top: 1rem;
}
.title {
  width: 100%;
  border-radius: 8px 8px 0 0;
  background: #ee8e38;
  color: #ffffff;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 0.89rem;
  font-weight: 500;
}
.Mtitle {
  width: 100%;
  color: #333;
  height: 23px;
  line-height: 23px;
  text-align: left;
  font-size: 23px;
  margin-left: 20px;
  display: none;
}
.register .mian .content {
  background: #fff;
  border-radius: 0 0 8px 8px;
  width: 100%;
  padding: 1rem 0;
}
.register .mian .content .inputK {
  width: 100%;
  height: 1.64rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
}
.register .mian .content .inputK >>> input {
  width: 13rem;
  height: 1.64rem;
  font-size: 0.52rem;
  background: #f4f4f4;
  border: 1px solid #dcdfe6;
  border-radius: 0.2rem;
  text-indent: 0.5rem;
}
.captcha {
  width: 13rem;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-bottom: 1rem;
}
.captcha input {
  width: 7rem;
  height: 1.64rem;
  font-size: 0.52rem;
  background: #f4f4f4;
  border: 1px solid #dcdfe6;
  border-radius: 0.2rem;
  text-indent: 0.5rem;
}
.captcha span {
  width: 5rem;
  height: 1.64rem;
  background: #f4f4f4;
  color: #999999;
  font-size: 0.59rem;
  line-height: 1.64rem;
  text-align: center;
  display: inline-block;
  border-radius: 4px;
}
.agree {
  width: 13rem;
  margin: 0 auto;
  font-size: 0.52rem;
  color: #333333;
  height: 0.52rem;
  line-height: 0.52rem;
  margin-bottom: 1rem;
}
.agree >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #333333;
}
.agree .orange {
  color: #ee8e38;
  cursor: pointer;
}
.butn {
  width: 13rem;
  margin: 0 auto;
  height: 1.64rem;
  background: #ee8e38;
  color: #ffffff;
  line-height: 1.64rem;
  text-align: center;
  font-size: 0.6rem;
  font-weight: 500;
  border-radius: 4px;
  margin-bottom: 1rem;
  cursor: pointer;
}
.goToLogin {
  text-align: center;
}
.goToLogin span {
  color: #ee8e38;
  cursor: pointer;
}
.footer {
  width: 100%;
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  padding: 0.8rem 0;
  color: #666666;
  font-size: 0.6rem;
}
@media screen and (max-width: 750px) {
  .footer {
    display: none;
  }
  .page-gray {
    background: #fff;
  }
  .title {
    display: none;
  }
  .Mtitle {
    display: block;
  }
}
</style>
